const BasicBlock = ({className = '', children}) => (
    <div className={className + " mb-3 mx-auto bg-indigo-50/50 rounded-lg p-2"}>
        {children}
    </div>
)

export default BasicBlock